document.addEventListener('click', function (e) {
  const btn = e.target.closest('.buy-now-trigger');
  if (!btn) return;

  const handle = btn.dataset.productHandle;
  const modal = document.getElementById('BuyNowModal');
  const content = document.getElementById('BuyNowModalContent');

  fetch(`/products/${handle}?view=buy-now`)
    .then(res => res.text())
    .then(html => {
      content.innerHTML = html;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('modal-open');
    });
});

document.addEventListener('click', function (e) {
  if (e.target.matches('[data-modal-close]')) {
    document.getElementById('BuyNowModal').setAttribute('aria-hidden', 'true');
    document.body.classList.remove('modal-open');
  }
});
